<template>
  <div class="app-sidebar">
    <div class="brand">
      教材征订系统
    </div>
    <el-menu
      :default-active="$route.path"
      background-color="#001529"
      text-color="#bfcbd9"
      active-text-color="#ffffff"
      router
      unique-opened
    >
      <template v-for="group in menuGroups">
        <el-menu-item
          v-if="group.children.length === 1"
          :key="group.children[0].path"
          :index="group.children[0].path"
        >
          <span slot="title">{{ group.label }}</span>
        </el-menu-item>
        <el-submenu
          v-else
          :key="group.label"
          :index="group.label"
        >
          <template slot="title">
            {{ group.label }}
          </template>
          <template v-for="item in group.children">
            <el-menu-item
              v-if="!item.children"
              :key="item.path"
              :index="item.path"
            >
              {{ item.label }}
            </el-menu-item>
            <el-submenu
              v-else
              :key="`${group.label}-${item.label}`"
              :index="`${group.label}-${item.label}`"
            >
              <template slot="title">
                {{ item.label }}
              </template>
              <el-menu-item
                v-for="child in item.children"
                :key="child.path"
                :index="child.path"
              >
                {{ child.label }}
              </el-menu-item>
            </el-submenu>
          </template>
        </el-submenu>
      </template>
    </el-menu>
  </div>
</template>

<script>
export default {
  name: "AppSidebar",
  computed: {
    menuGroups() {
      const role = this.$store.state.platform.currentRole;
      return (this.$store.state.platform.roles[role] || {}).menus || [];
    }
  }
};
</script>
